import config from "./appconf";
import {
  store,
  startGame,
  playerPassed,
  diceRolled,
  playerUnreadied,
  playerReadied,
  playerDisconnected,
  playerConnected,
  playerJoined,
  playerQuit,
  youQuit,
  youLoggedOut,
  boxMarked,
  turnAdvanced,
  phaseAdvanced,
  gameEnded,
  colorLocked,
  disconnectModalEnabled,
  disconnectModalDisabled,
} from "./store";
import { EventType, SessionEventData } from "./common/Events";
import { ColorLockEventInfo } from "common/Info";

let eventSource: EventSource;

function connectToSSE() {
  if (eventSource && eventSource.readyState === eventSource.OPEN) {
    console.log("SSE has already been connected. Skipping connection attempt");
    return;
  } else if (eventSource && eventSource.readyState === eventSource.CONNECTING) {
    console.log(
      "Another SSE connection attempt is already in progress. Skipping this connection attempt.",
    );
    return;
  } else {
    console.log("attempting to connect to SSE");
  }
  eventSource = new EventSource(`${config.baseUrl}/api/v1/events`, {
    withCredentials: true,
  });
  eventSource.onmessage = (event) => {
    console.log("received message");
    console.log(event);
  };

  eventSource.onerror = (event) => {
    console.log("Error connecting to SSE Event Source");
    console.log(event);
    store.dispatch(disconnectModalEnabled());
  };

  eventSource.onopen = () => {
    console.log("SSE connection opened");
    store.dispatch(disconnectModalDisabled());
  };

  eventSource.addEventListener(EventType.playerJoined, (event) => {
    console.log("Received playerJoined event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(playerJoined(data.session.players));
  });

  eventSource.addEventListener(EventType.playerConnected, (event) => {
    console.log("Received playerConnected event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(playerConnected(data.session.players));
  });

  eventSource.addEventListener(EventType.playerDisconnected, (event) => {
    console.log("Received playerDisconnected event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(playerDisconnected(data.session.players));
  });

  eventSource.addEventListener(EventType.playerReadied, (event) => {
    console.log("Received playerReadied event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(playerReadied(data.session.players));
  });

  eventSource.addEventListener(EventType.playerUnreadied, (event) => {
    console.log("Received playerUnreadied event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(playerUnreadied(data.session.players));
  });

  eventSource.addEventListener(EventType.playerQuit, (event) => {
    console.log("Received playerQuit event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(playerUnreadied(data.session.players));
  });

  eventSource.addEventListener(EventType.diceRolled, (event) => {
    console.log("Received diceRolled event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(diceRolled(data.session));
  });

  eventSource.addEventListener(EventType.playerPassed, (event) => {
    console.log("Received playerPassed event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(playerPassed(data.session));
  });

  eventSource.addEventListener(EventType.gameStarted, (event) => {
    console.log("Received game start event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(startGame(data.session));
  });

  eventSource.addEventListener(EventType.boxMarked, (event) => {
    console.log("Received box marked event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(boxMarked(data.session.players));
  });

  eventSource.addEventListener(EventType.turnAdvanced, (event) => {
    console.log("Received turnAdvanced event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(turnAdvanced(data.session));
  });

  eventSource.addEventListener(EventType.phaseAdvanced, (event) => {
    console.log("Received phaseAdvanced event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(phaseAdvanced(data.session));
  });

  eventSource.addEventListener(EventType.gameEnded, (event) => {
    console.log("Received gameEnded event");
    const data: SessionEventData = JSON.parse(event.data);
    console.log(data);
    store.dispatch(gameEnded(data.session));
  });

  eventSource.addEventListener(EventType.colorLocked, (event) => {
    const data: ColorLockEventInfo = JSON.parse(event.data);
    console.log("Received colorLocked event");
    store.dispatch(colorLocked(data));
  });

  eventSource.addEventListener(EventType.youLoggedOut, () => {
    console.log("recevied a youLoggedOut event");
    store.dispatch(youLoggedOut());
    closeSSE();
  });

  eventSource.addEventListener(EventType.youQuit, () => {
    console.log("recevied a youQuit event");
    store.dispatch(youQuit());
  });
}

function closeSSE() {
  console.log("Attempting to close SSE connection");
  eventSource.close();
  console.log("SSE connection closed");
}

export { connectToSSE, closeSSE };
